import { environment } from '../environments/environment';
export const authConfig: any = {
    authority: environment.authConfig.authority,
    client_id: environment.authConfig.clientId,
    redirect_uri: environment.authConfig.redirectUri,
    post_logout_redirect_uri: environment.authConfig.postLogoutRedirectUri,
    response_type: 'code',
    scope: environment.authConfig.scope,
   // state: "oauth2",

    silent_redirect_uri: environment.authConfig["silentRedirectUri"],
    automaticSilentRenew: true,
    accessTokenExpiringNotificationTime: 60,
//   // silentRequestTimeout:10000,
    filterProtocolClaims: true,
    loadUserInfo: true
};



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/auth.config.ts